import {
  Input,
  Form,
  Select,
  TreeSelect,
} from 'antd'
import React from 'react'

import AvatarUploader from '@/components/fields/avatar-uploader'
import { genderOptions } from '@/constants/gender'
import { GroupType } from '@/model/group'
import { selectGroupTreeData } from '@/redux/group-selectors'
import { useAppSelector } from '@/redux/utils'

const { Item } = Form

export default function CreatorFields({
  isCreating,
}: { isCreating?: boolean }) {
  const treeData = useAppSelector((state) => selectGroupTreeData(state, GroupType.Creator))

  return (
    <>
      <Item name="id" hidden />
      <Item name="avatarUrl" label="Headshot">
        <AvatarUploader />
      </Item>
      <Item name="name" label="Creator Name" required rules={[{ required: true }]}>
        <Input />
      </Item>
      <Item name="bio" label="bio" required rules={[{ required: true }]}>
        <Input />
      </Item>
      <Item name="gender" label="Gender" required rules={[{ required: true }]}>
        <Select options={genderOptions} />
      </Item>
      {isCreating && (
        <Item name="email" label="Email" required rules={[{ required: true }]}>
          <Input />
        </Item>
      )}
      <Item name="groupId" label="Creator Group" required rules={[{ required: true }]}>
        <TreeSelect<number> treeData={treeData} treeDefaultExpandAll style={{ maxWidth: 230 }} />
      </Item>
    </>
  )
}
